import utils from "./utils";
import { isV2Path } from "./v2Routes";

const basePath = utils.getEdgeBasePath();

export function resolveUiDesignLane(pathname) {
  return isV2Path(pathname) ? "v2" : "legacy";
}

export async function submitUiExperimentFeedback({
  kind,
  comment,
  pagePath,
  designLane,
  nickname,
  attachment,
}) {
  const formData = new FormData();
  formData.append("kind", kind);
  formData.append("comment", comment);
  if (pagePath) formData.append("pagePath", pagePath);
  if (designLane) formData.append("designLane", designLane);
  if (nickname) formData.append("nickname", nickname);
  if (attachment) formData.append("attachment", attachment);

  const response = await fetch(`${basePath}/api/v1/ui-experiments/v2/feedback`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });
  const data = await response.json();
  if (!response.ok || data?.ok === false) {
    throw new Error(data?.message || "Failed to submit feedback");
  }
  return data;
}
